<script lang="ts">
    import RewardsIcon from "@apps/rewards/components/RewardsIcon.svelte";
    import type { TranslationNamespaces } from "@apps/rewards/types";

    import T from "@components/T.svelte";

    import RewardsPageActionCompletedIcon from "./icons/RewardsPageActionCompletedIcon.svelte";

    //Props
    export let namespace: TranslationNamespaces;
</script>

<div class="gw-rd-page-widget-action-completed">
    <T {namespace} translationKey="action_completed" />
    <RewardsIcon size="small">
        <RewardsPageActionCompletedIcon />
    </RewardsIcon>
</div>

<style lang="postcss">
    .gw-rd-page-widget-action-completed {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: var(--gw-rd-space-4);
        line-height: normal;
    }
</style>
